import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import { Icon } from 'leaflet';
import { stringify } from 'qs';
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
export {
  initVeeValidateRulesWithI18n,
  setVeeValidateLocale,
} from './vee-validate';

import BooleanIndicator from '@/components/BooleanIndicator.vue';
import MessagesList from '@/components/MessagesList.vue';
import ValidatingGroup from '@gid/vue-common/components/ValidatingGroup';
import AddToHomeScreen from '@gid/vue-common/components/AddToHomeScreen';
import Offline from '@gid/vue-common/components/Offline';
import BackButton from '@gid/vue-common/components/BackButton';
import RefreshButton from '@gid/vue-common/components/RefreshButton';

Vue.use(BootstrapVue);

Vue.component('bool-indicator', BooleanIndicator);
Vue.component('messages-list', MessagesList);
Vue.component('multiselect', Multiselect);
Vue.component('validating-group', ValidatingGroup);
Vue.component('add-to-home-screen', AddToHomeScreen);
Vue.component('offline', Offline);
Vue.component('back-button', BackButton);
Vue.component('refresh-button', RefreshButton);

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

axios.defaults.paramsSerializer = (params) => {
  return stringify(params, {
    arrayFormat: 'repeat',
    skipNulls: true,
  });
};
